import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Device} from 'src/app/models';

@Component({
    selector: 'app-device-delete',
    templateUrl: './device-delete.component.html'
})
export class DeleteDeviceDialogComponent {
    device: Device;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.device = new Device();
        this.device.name = data.name;
    }
}
